
import {
  gql, useQuery 
} from "@apollo/client";
import {
  useUserContext 
} from "@/context/user"

export const useGetReferAFriendConfig = () => {
  const GET_STORE_CONFIG_REFER_A_FRIEND = gql`
        query GetStoreConfig {
            storeConfig {
                store_code
                refer_a_friend_config {
                    enable_mode
                    enable_reward_by_order
                    reward_type
                    reward_amount
                    refer_reward_type
                    refer_reward_amount
                    minimum_cart_value
                    
                }
            }
        }`;

  const {
    loading, error, data 
  } = useQuery(GET_STORE_CONFIG_REFER_A_FRIEND, {
    cachePolicy: "no-cache",
    nextFetchPolicy: "no-cache"
  });

  const [{
    isSignedIn 
  }] = useUserContext()

    
  const {
    storeConfig
  } = data || {};
  const {
    refer_a_friend_config
  } = storeConfig || {};


  const {
    enable_mode,
    enable_reward_by_order,
    reward_type,
    reward_amount,
    refer_reward_type,
    refer_reward_amount,
    minimum_cart_value
  } = refer_a_friend_config || {};


  return {
    loading,
    error, 
    enable_mode,
    enable_reward_by_order,
    reward_type,
    reward_amount,
    refer_reward_type,
    refer_reward_amount,
    minimum_cart_value
  }
}
